<template>
  <div class="md-layout">
    <div
      class="md-layout-item"
      :class="
        fullWidth
          ? 'md-size-100'
          : 'md-xsmall-size-100 md-small-size-60 md-medium-size-50 md-size-35'
      "
    >
      <md-table>
        <md-table-toolbar>
          <md-field>
            <md-icon v-if="!isIOSDevice">search</md-icon>
            <md-input
              type="search"
              class="mb-4"
              style="margin-top: 10px"
              clearable
              :placeholder="customPlaceHolder"
              v-model="searchText"
            ></md-input>
          </md-field>
        </md-table-toolbar>
      </md-table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    customPlaceHolder: {
      type: String,
    },
    fullWidth: {
      type: Boolean,
      require: false,
      default: false,
    },
    clearSearch: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  data() {
    return {
      searchText: '',
    };
  },
  watch: {
    searchText() {
      this.$emit('search', this.searchText);
    },
  },
  computed: {
    isIOSDevice() {
      return (
        !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
      );
    },
  },
  methods: {
    clearSearchText() {
      this.searchText = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/generic/_searchBar.scss';
</style>
